"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var Timezone = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(Timezone, _Record);

  function Timezone() {
    (0, _classCallCheck2.default)(this, Timezone);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Timezone).apply(this, arguments));
  }

  (0, _createClass2.default)(Timezone, [{
    key: "identifier",
    value: function identifier() {
      return this.momentTimezones.first();
    }
  }]);
  return Timezone;
}((0, _immutable.Record)({
  offset: '',
  name: '',
  momentTimezones: (0, _immutable.List)()
}));

exports.default = Timezone;
module.exports = exports.default;